import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import EvaluationQuestionSave from '@/domains/evaluation/question-save/main';

export default {
	name: 'EvaluationQuestions',
	data: () => ({
		model: {
			questions: [],
			students: []
		}
	}),
	computed: {
		...mapGetters([
			'evaluationQuestions',
			'evaluationStudentsQuestions'
		])
	},
	components: {
		EvaluationQuestionSave
	},
	methods: {
		...mapActions([
			'setEvaluationQuestionAnswer',
			'clearEvaluationQuestion'
		]),
		onChange(student, question, answer) {

			this.setEvaluationQuestionAnswer({
				student,
				question,
				answer
			});

		}
	},
	created() {

		EventBus.$on('evaluationQuestionFetched', () => {

			this.model.questions = cloneDeep(this.evaluationQuestions);
			this.model.students = cloneDeep(this.evaluationStudentsQuestions);

		});

		EventBus.$on('classChanged', () => {

			this.clearEvaluationQuestion();

			this.model.questions = [];
			this.model.students = [];

		});

	}
};



// WEBPACK FOOTER //
// ./sources/domains/evaluation/questions/index.js